import { object, string } from "yup";
import i18next from "/app/src/locales/config";

export const userResetSchema = object().shape({
  search: string().required(i18next.t("translation:field_is_required")),
});
